import { NavLink } from "react-router-dom";
import profile from "./profile.jpg";
import { useState } from "react";
import FacebookPage from "./page.jpg";
export const Sidebar = () => {
  const [showmore, setshowmore] = useState(true);
  let showmorefun = () => {
    setshowmore(!showmore);
  };
  const handleClick = (index) => {
    // Update the activeIndex value in sessionStorage
    sessionStorage.setItem("activeIndex", index);
  };
  return (
    <>
      <div className="sidebar col-3 d-none d-lg-block p-0">
        <div className="sidebarContainer">
          <div className={!showmore ? "sidebarMenu fullmenu" : "sidebarMenu"}>
            <NavLink classname="menulink " to="/profile" onClick={() => handleClick(null)}>
              <img src={profile} alt="" className="me-1 profile" />
              <span className="ms-2">Sû Jøy</span>
            </NavLink>
            <NavLink classname="menulink">
              <i
                data-visualcompletion="css-img"
                className="linkicon"
                style={{
                  backgroundImage:
                    "url(https://static.xx.fbcdn.net/rsrc.php/v4/yt/r/rJ9k6SVFtYN.png)",
                }}
              ></i>
              <span>Meta AI</span>
            </NavLink>
            <NavLink classname="menulink">
              <i
                data-visualcompletion="css-img"
                className=""
                style={{
                  backgroundImage:
                    "url('https://static.xx.fbcdn.net/rsrc.php/v4/yh/r/FlnJwE1zAUa.png')",
                  backgroundPosition: "0px -777px",
                  backgroundSize: "auto",
                  width: "36px",
                  height: "36px",
                  backgroundRepeat: "no-repeat",
                  display: "inline-block",
                }}
              ></i>

              <span>Friends</span>
            </NavLink>

            <NavLink classname="menulink" to="/video" onClick={() => handleClick(2)}>
              <img
                draggable={false}
                height={36}
                width={36}
                className="xz74otr"
                alt=""
                referrerPolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v4/yJ/r/fGWbDwbx9W4.png"
              />

              <span>Video</span>
            </NavLink>
            <NavLink classname="menulink" to="/groups" onClick={() => handleClick(4)}>
              <i
                data-visualcompletion="css-img"
                style={{
                  backgroundImage:
                    "url('https://static.xx.fbcdn.net/rsrc.php/v4/yh/r/FlnJwE1zAUa.png')",
                  backgroundPosition: "0px -777px",
                  width: 36,
                  height: 36,
                  backgroundRepeat: "no-repeat",
                  display: "inline-block",
                }}
              />
              <span>Groups</span>
            </NavLink>
            <NavLink classname="menulink" to="/marketplace" onClick={() => handleClick(3)}>
              <i
                data-visualcompletion="css-img"
                className=""
                style={{
                  backgroundImage:
                    "url('https://static.xx.fbcdn.net/rsrc.php/v4/yh/r/FlnJwE1zAUa.png')",
                  backgroundPosition: "0px -925px",
                  backgroundSize: "auto",
                  width: "36px",
                  height: "36px",
                  backgroundRepeat: "no-repeat",
                  display: "inline-block",
                }}
              ></i>

              <span>Marketplace</span>
            </NavLink>
            <NavLink classname="menulink" to="/games" onClick={() => handleClick(5)}>
              <i
                data-visualcompletion="css-img"
                className=""
                style={{
                  backgroundImage:
                    "url('https://static.xx.fbcdn.net/rsrc.php/v4/yh/r/FlnJwE1zAUa.png')",
                  backgroundPosition: "0px -259px",
                  backgroundSize: "auto",
                  width: 36,
                  height: 36,
                  backgroundRepeat: "no-repeat",
                  display: "inline-block",
                }}
              ></i>

              <span>Play Games</span>
            </NavLink>
            <NavLink classname="menulink feeds">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                className="ms-1"
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/yb/r/eECk3ceTaHJ.png"
                style={{ transform: "scale(0.85)" }}
              />
              <span className="">Feeds</span>
            </NavLink>

            <NavLink classname="menulink">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/yD/r/CwKNCefmHON.png"
              />
              <span>Add Centre</span>
            </NavLink>
            <NavLink classname="menulink">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/yN/r/ATlxuj_J5ty.png"
              />
              <span>Add Manager</span>
            </NavLink>

            <NavLink classname="menulink">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/y3/r/Jr0q8qKF2-Y.png"
              />
              <span>Climate Science Center</span>
            </NavLink>
            <NavLink classname="menulink">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/yq/r/fNPcDZC-2PD.png"
              />
              <span>Crisis Response</span>
            </NavLink>

            <NavLink classname="menulink">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/yJ/r/fGWbDwbx9W4.png"
              />
              <span>Gaming video</span>
            </NavLink>

            <NavLink classname="menulink">
              <i
                data-visualcompletion="css-img"
                className=""
                style={{
                  backgroundImage:
                    "url(https://static.xx.fbcdn.net/rsrc.php/v3/yz/r/4GR4KRf3hN2.png)",
                  backgroundPosition: "0px -111px",
                }}
              ></i>
              <span>Pages</span>
            </NavLink>

            <NavLink classname="menulink">
              <img
                draggable="false"
                height="34"
                width="34"
                alt=""
                referrerpolicy="origin-when-cross-origin"
                src="https://static.xx.fbcdn.net/rsrc.php/v3/yv/r/x2_LFd7gCqg.png"
              />
              <span>Recent Add Activity</span>
            </NavLink>
            <NavLink
              className={showmore ? "showmoreActive menulink showmore" : "showmore menulink"}
              onClick={() => showmorefun()}
            >
              <div className="showmoreIcon">
                {showmore ? (
                  <svg
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    width="1em"
                    height="1em"
                    className="x1lliihq x1k90msu x2h7rmj x1qfuztq x198g3q0 x1qx5ct2 xw4jnvo"
                  >
                    <g fillRule="evenodd" transform="translate(-448 -544)">
                      <path
                        fillRule="nonzero"
                        d="M452.707 549.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L456 552.586l-3.293-3.293z"
                      ></path>
                    </g>
                  </svg>
                ) : (
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    width="1em"
                    height="1em"
                    className="x1lliihq x1k90msu x2h7rmj x1qfuztq x198g3q0 x1qx5ct2 xw4jnvo"
                  >
                    <path d="M15.47 12.2 10 6.727 4.53 12.2a.75.75 0 0 1-1.06-1.061l6-6a.751.751 0 0 1 1.06 0l6 6a.75.75 0 0 1-1.06 1.061z"></path>
                  </svg>
                )}
              </div>
              <span>{showmore ? "See more" : "See less"}</span>
            </NavLink>
          </div>
          <div className="shortCurts">
            <h3>Your Shortcuts</h3>

            <NavLink>
              <img alt="" className="shortcutsImg circle" src={FacebookPage} />
              <span>S.G</span>
            </NavLink>

            <span className="sidebarFooter">
              Privacy · Terms · Advertising · Ad choices
              <i
                data-visualcompletion="css-img"
                className="x1b0d499 x1d69dk1"
                style={{
                  backgroundImage:
                    "url(https://static.xx.fbcdn.net/rsrc.php/v3/y5/r/eKbbhUjvYo3.png)",
                  backgroundPosition: "-51px -143px",
                  backgroundSize: "auto",
                  width: "12px",
                  height: "10px",
                  backgroundRepeat: "no-repeat",
                  display: "inline-block",
                  opacity: ".6",
                  margin: "0px 2px",
                }}
              ></i>
              · Cookies · More · Meta © 2026
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
